import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProfileData, UserPreference } from 'src/app/common/models/loginPreference.model';

@Injectable({
	providedIn: 'root'
})
export class DataService {
	private readonly userProfileSubject = new BehaviorSubject<UserPreference>(null);

	private readonly partsSelected = new BehaviorSubject<any>({});
	currentPartsData = this.partsSelected.asObservable();

	private readonly barcodeScanDetails = new BehaviorSubject<any>({});
	currentBarcodeScanDetail = this.barcodeScanDetails.asObservable();

	private readonly userDetails = new BehaviorSubject<any>({});
	currentUserDetails = this.userDetails.asObservable();

	private readonly userPreferencesSubject: BehaviorSubject<any> = new BehaviorSubject<any>(this.getUserPreferences());
	private readonly pieTokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

	private readonly stepNumber = new BehaviorSubject<number>(1);
	private readonly userIdSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
	private readonly userIdRoleSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
	private readonly workDayIdSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

	currentSection = this.stepNumber.asObservable();

	updateStepNumber(newStepNumber: number): void {
		sessionStorage.setItem('currentSection', JSON.stringify(newStepNumber));
		this.stepNumber.next(newStepNumber);
	}

	getStepNumber(): number {
		const savedPreferences = sessionStorage.getItem('currentSection');
		return savedPreferences ? Number(savedPreferences) : this.stepNumber.getValue();
	}
	partsCountListChange(partsCountNewData: any): void {
		this.partsSelected.next(partsCountNewData);
	}

	scannedPart(currentBarcodeScanDetail: any): void {
		this.barcodeScanDetails.next(currentBarcodeScanDetail);
	}

	updateUserDetails(currentUserDetails: any): void {
		this.userDetails.next(currentUserDetails);
	}

	sessionStorageSetItem(keyName: string, value: string): void {
		sessionStorage.setItem(keyName, value);
	}


	sessionStorageGetItem(keyName: string): string | null {
		return sessionStorage.getItem(keyName);
	}


	public getUserPreferences(): ProfileData | null {
		const savedPreferences = sessionStorage.getItem('userPreference');
		return savedPreferences ? JSON.parse(savedPreferences) : null;
	}

	public setUserPreferences(preferences: any): void {
		sessionStorage.setItem('userPreference', JSON.stringify(preferences));
		this.userPreferencesSubject.next(preferences);
	}

	public getUserPreferencesObservable(): Observable<any> {
		return this.userPreferencesSubject.asObservable();
	}

	public setPieToken(pieToken: string): void {
		this.pieTokenSubject.next(pieToken);
	}

	public getPieToken(): string {
		return this.pieTokenSubject.getValue();
	}

	public setUserId(userId: string): void {
		this.userIdSubject.next(userId);
	}
	public getUserId(): string {
		return this.userIdSubject.getValue();
	}

	public setUserRoleId(userRoleId: string): void {
		this.userIdRoleSubject.next(userRoleId);
	}

	public getUserRoleId(): string {
		return this.userIdRoleSubject.getValue();
	}
  
	public setUserProfile(profile: UserPreference):void {
	  this.userProfileSubject.next(profile);
	}
  
	public getUserProfile(): Observable<UserPreference> {
	  return this.userProfileSubject.asObservable();
	}

	public setWorkDayId(workDayId: string): void {
		this.workDayIdSubject.next(workDayId);
	}
	public getWorkDayId(): string {
		return this.workDayIdSubject.getValue();
	}

}
